
<div class="col-12">
  <div>
    <h3 class="title">{{title}}</h3>
  </div>
  <div class="mt-3">
    <span class="font-weight-bold">All Suppliers Apps</span>
  </div>
  <div class="row col-12 mt-3 mx-0">
    <div class="col-md-3 col-xl-2 border-right">
      <div *ngFor="let item of listApp" (click)="selectApp(item.id)" class="p-2 app-item" [ngClass]="selected===item.id ? 'bg-color' : ''">
        <span>{{item.name}}</span>
      </div>
    </div>
    <div class="col-md-9 col-xl-10 pr-0">
      <div class="w-100">
        <span class="font-weight-bold">Assignment Group</span>
        <div class="row col-12 d-flex align-items-center mx-0 pr-0">
          <div class="col-9">
            <mat-form-field floatLabel="never" appearance="outline" class="col-11 p-0 input-name">
              <input matInput placeholder="Enter group name" style="color: #18181a;" [formControl]="appName" required
              [maxLength]="100">
              <mat-hint align="end">{{appName.value.length || 0}} / 100</mat-hint>
          </mat-form-field>
          </div>
          <div class="col-3">
            <button class="btn button btn-primary btn-add mb-2" (click)="save()">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>